import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { APP_ROUTE } from './app.routes';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { DirectionService, LanguageService } from '@core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { httpInterceptorProviders } from '@core/interceptor';
import { AppInitService } from '@core/service/app-init.service';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { CustomTranslateLoader } from '@core/service/custom-translate-loader';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { Configuration } from '@core/api';
import { environment } from 'environments/environment';
import { provideZoneChangeDetection } from "@angular/core";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideHttpClient(withInterceptorsFromDi()),
        provideRouter(APP_ROUTE, withComponentInputBinding()),
        DirectionService,
        LanguageService,
        importProvidersFrom(
            TranslateModule.forRoot({
                fallbackLang: 'en',
                loader: {
                    provide: TranslateLoader,
                    useClass: CustomTranslateLoader,
                },
            }),
            FeatherModule.pick(allIcons),
            LoadingBarRouterModule,
        ),       
        httpInterceptorProviders,
        {
            provide: Configuration,
            useValue: new Configuration({
                basePath: environment.apiBaseUrl,
            })
        },
        provideAppInitializer(() => {
            return inject(AppInitService).init();
        }),
        provideAnimationsAsync(), // TODO: remove this deprecated provider when 'ngx-mat-multi-sort' package doesn't need it anymore
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'outline' }
        }
    ],
};
